import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from "@mui/material/Tooltip";
import {binaryToBool, boolToBinary, checkNull, checkNullStr, getDefStr, isBoolTrue} from "../utils/ReactUtils";
import {Popover} from "../index";
import {IconClass, THEME} from "../config/FusionConfig";

// const Popover = withStyles((theme) => ({
//     tooltip: {
//         color: "black",
//         fontsize: `${FsVarVariant.MD} !important`,
//         textAlign: "justify",
//         display: "flex",
//         padding: ".15rem .3rem !important",
//         justifyContent: "center",
//         boxShadow: "var(--shadowLg)",
//         backgroundColor: "white",
//         borderRadius: ".5rem",
//         width: "auto", // Set your desired width
//         minWidth: "auto", // Set your desired width
//         maxWidth: "300px", // Set your desired width
//         // height: '180px', // Set your desired height
//         maxHeight: "180px", // Set your desired height
//         // overflow: 'auto', // Enable scroll bar when content overflows
//     },
// }))(Tooltip);

const Checkbox = React.memo(({
                                 className = "",
                                 wrapperClassName = "",
                                 labelClassName = "",
                                 subtitleClassName = "",
                                 tagClassName = "",
                                 endSubtitleClassName = "",
                                 id,
                                 key,
                                 subtitle,
                                 endSubtitle,
                                 tag,
                                 tagTooltip,
                                 subtitleTooltip,
                                 endSubtitleTooltip,
                                 justifySubtitlesAt = 'between',
                                 tooltipText,
                                 endComponent,

                                 hidden = false,
                                 disabled = false,
                                 tooltip = true,
                                 scrolled = true,
                                 binary = false,
                                 precision = false,
                                 tooltipWordLimit = 30,
                                 fontSize = '',
                                 height,
                                 type = 'checkbox',
                                 alignAt = 'center',
                                 justifyAt = 'start',
                                 roundedVariant = '2',
                                 checkmarkMarginTop = '',
                                 // checkmarkMarginTop = '.15rem',
                                 labelColor,

                                 children,
                                 onChange,
                                 checked,
                                 defaultChecked,
                                 variant = THEME,
                                 highlightHoverVariant = 'dark',
                                 selectedHighlightVariant = '',
                                 highlightVariant = '',
                                 outlined = false,
                                 py = '1',
                                 px = '1',
                                 iMsg = '',
                                 iMsgIcon = IconClass.iButtonFill,

                                 style = {},
                                 wrapperStyle = {},
                                 labelStyle = {},
                                 subtitleStyle = {},
                                 tagStyle = {},
                                 endSubtitleStyle = {},
                                 ...rest
                             }) => {
    const TAG = "Checkbox";

    // useEffect(() => {
    // console.log(TAG, 'checked:', checked, 'defaultChecked:', defaultChecked);
    // }, [checked]);


    return (!isBoolTrue(hidden) && <>
        <Tooltip
            className={'text-block'}
            sx={{textAlign: "justify"}}
            style={{textAlign: "justify"}}
            TransitionProps={{textAlign: "justify"}}
            PopperProps={{textAlign: "justify"}}
            title={isBoolTrue(tooltip) ? (((getDefStr(tooltipText, children) + "").length >= tooltipWordLimit) ? getDefStr(tooltipText, children) : "") : ""}>
            <label
                key={key}
                className={`cb-label text-nowrap m-0 w-100 cursor-pointer rounded-${roundedVariant}   
                        ${isBoolTrue(scrolled) ? 'scroller scroller-x-auto no-bar' : ''} 
                        ${isBoolTrue(disabled) ? 'disable-item' : ''} 
                        ${checkNullStr(children) ? `px-${px} py-${py}` : 'p-0'} 
                         d-flex flex-nowrap jc-${justifyAt} al-${alignAt} bg-infox overflow-hidden ${wrapperClassName}
                          transition highlight-${highlightVariant} highlight-${highlightHoverVariant}-hover
                         ${isBoolTrue(defaultChecked) || isBoolTrue(checked) ? `highlight-${selectedHighlightVariant}` : ''}
                         ${isBoolTrue(outlined) ? `border-${selectedHighlightVariant}-dark border-${highlightHoverVariant}-hover` : ''}
                        `}
                style={{
                    fontSize: fontSize,
                    height: height,
                    // border: isBoolTrue(outlined) ? `1.3px solid var(--${variant}Dark)` : 'none',
                    borderWidth: isBoolTrue(outlined) ? `1.3px` : 'none',
                    borderStyle: isBoolTrue(outlined) ? `solid` : 'none',
                    ...wrapperStyle
                }}
            >
                <input className={`p-0 m-0x cursor-pointer ${className} ${variant}x ${isBoolTrue(disabled) ? 'disable-item' : ''}`}
                       style={{margin: `${checkmarkMarginTop} 0 0 0`, ...style}}
                       type={type}
                       disabled={disabled}
                       checked={isBoolTrue(binary) ? binaryToBool(checked) : checked}
                       defaultChecked={isBoolTrue(binary) ? binaryToBool(defaultChecked) : defaultChecked}
                       onChange={(e) => {
                           const value = e.target.checked;
                           // printLog(children + ".value:", value);
                           if (checkNull(onChange)) onChange(e, isBoolTrue(binary) ? boolToBinary(value) : value, children);
                       }}
                       {...rest}
                />
                {(checkNullStr(subtitle) || checkNullStr(endSubtitle) || checkNullStr(tag) || checkNull(children) || checkNullStr(iMsg) || checkNull(endComponent)) &&
                    <span
                        className={`d-flex w-100 px-1 cb-text jc-${justifySubtitlesAt} al-center text-nowrap flex-nowrap fd-row position-relative ${labelClassName} ${isBoolTrue(disabled) ? 'disable-item' : ''} `}
                        style={{
                            color: labelColor,
                            ...labelStyle
                        }}>
                    <span className={`w-auto ${isBoolTrue(disabled) ? 'disable-item-lg' : ''} `}>
                        <span>{children}</span>
                        {checkNullStr(subtitle) &&
                            <Tooltip title={getDefStr(subtitleTooltip)}>
                                <span className={`fs-md-sm text-gray-dark-high px-1 ps-3 ${subtitleClassName}`}
                                      style={subtitleStyle}
                                      onContextMenu={(e) => isBoolTrue(subtitleTooltip) && e.preventDefault()}>
                                        {subtitle}
                                </span>
                            </Tooltip>}
                    </span>

                        {(checkNullStr(tag) || checkNullStr(endSubtitle) || checkNullStr(iMsg) || checkNull(endComponent)) &&
                            <span
                                className={`d-flex px-1 cb-text jc-end al-center text-nowrap flex-nowrap fd-row `}>
                                {checkNullStr(tag) &&
                                    <Tooltip title={getDefStr(tagTooltip)}>
                                        <span className={`fs-md-sm text-dark bg-primary-25 text-white rounded-10 fw-semi-bold px-2 me-2 ${tagClassName}`}
                                              style={{color: 'white !important', ...tagStyle}}
                                              onContextMenu={(e) => isBoolTrue(tagTooltip) && e.preventDefault()}>
                                                {tag}
                                        </span>
                                    </Tooltip>}

                                {checkNullStr(endSubtitle) &&
                                    <Tooltip title={getDefStr(endSubtitleTooltip)}>
                                    <span className={`fs-md-sm text-gray-dark-high px-1 ${endSubtitleClassName}`}
                                          style={endSubtitleStyle}
                                          onContextMenu={(e) => isBoolTrue(endSubtitleTooltip) && e.preventDefault()}>
                                    {endSubtitle}
                                    </span>
                                    </Tooltip>}

                                {/*i-button*/}
                                {(checkNullStr(iMsg) && !isBoolTrue(disabled)) &&
                                    <span className={'px-1 ps-2 bg-dangerx'}
                                          onContextMenu={(e) => e.preventDefault()}>
                                        <Popover
                                            title={<span className={`p-2x x`}>{iMsg}</span>}
                                            // classes={{tooltip: "scroller scroller-y-auto scroll-dark p-2"}}
                                        >
                                            <i className={`text-gray-dark transition cursor-pointer highlight-text-${variant}-hover ${iMsgIcon}`}
                                               onContextMenu={(e) => e.preventDefault()}/>
                                        </Popover>
                                </span>}

                                {/*endComponent*/}
                                {endComponent && endComponent}
                    </span>}
                </span>}
            </label>
        </Tooltip>
    </>)

});

Checkbox.propTypes = {
    className: PropTypes.string,
    wrapperClassName: PropTypes.string,
    type: PropTypes.string,
    labelClassName: PropTypes.string,
    id: PropTypes.string,
    fontSize: PropTypes.string,
    key: PropTypes.string,
    children: PropTypes.any,
    style: PropTypes.object,
    wrapperStyle: PropTypes.object,
    onChange: PropTypes.func,
    tooltip: PropTypes.bool,
    disabled: PropTypes.bool,
    subtitle: PropTypes.string,
    tag: PropTypes.string,
    tagTooltip: PropTypes.string,
    subtitleTooltip: PropTypes.string,
    tooltipText: PropTypes.string,
    endSubtitleTooltip: PropTypes.string,
    height: PropTypes.string,
    binary: PropTypes.bool,
    defaultChecked: PropTypes.bool,
    checked: PropTypes.bool,
    scrolled: PropTypes.bool,
    highlightVariant: PropTypes.string,
    highlightHoverVariant: PropTypes.string,
    selectedHighlightVariant: PropTypes.string,
    labelStyle: PropTypes.object,
    tooltipWordLimit: PropTypes.number,
};
export default Checkbox;
